export default __webpack_public_path__ + "static/media/dcca.d573c840.png";